import { StudyProgrammesTab } from './studyProgrammesTab';

export const myStudyProgrammesTabComponent = {
  template: require('./studyProgrammesTab.html'),
  controllerAs: 'ctrl',
  controller: StudyProgrammesTab,
};
